import Constants from '../../constants/api';
import DatePicker from 'react-date-picker';
import React from 'react';
import { validateField } from '../shared/form-popup';

export const StepForm = ({ dispatch, parentState }) => {
  window.history.pushState("", "", '/checkout/zaqvi');

  const { firstName,
    firstNameIsValid,
    secondName,
    secondNameIsValid,
    telephone,
    telephoneIsValid,
    email,
    emailIsValid,
    city,
    cityIsValid,
    address,
    addressIsValid,
    selectedDate,
    selectedDateIsValid,
    agreeCheckbox,
    packageInfo,
    failure } = parentState;

  const createBody = () => {
    const packageString = packageInfo.toString();

    const user = "\n<br>Клиентски данни: "
      + "\n<br>Имена: " + firstName + " " + secondName
      + "\n<br>Телефон: " + telephone
      + "\n<br>Имейл: " + email
      + "\n<br>Град: " + city
      + "\n<br>Адрес: " + address
      + "\n<br>Желана дата за вкл.: " + formatDate(selectedDate);

    return user + "\n<br>---------------\n<br>" + packageString;

  }

  const onSubmit = (e) => {
    e.preventDefault();

    if (checkFields()) {
      let send_to = 'callcenter@netsurf.bg';
      const subject = 'Избран ' + packageInfo.internalTitle + ', ' + telephone + ', ' + city;
      const body = createBody();
      const reply_to = email;

      const emailObj = {
        send_to: send_to,
        subject: subject,
        body: body,
        reply_to: reply_to
      };

      const headers = new Headers();
      headers.append('Content-Type', 'application/json');

      const POSToptions = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(emailObj)
      }

      const request = new Request(Constants.MAIL_URL, POSToptions);

      fetch(request)
        .then((res) => {
          if (res.status === 200) {
            dispatch({ type: 'next_step' });
          } else {
            dispatch({ type: 'failure' });
          }
        })
        .catch(e => {
          dispatch({ type: 'failure' });
        });
    }
  }

  const checkFields = () => {
    const fn = validateField('name', firstName);
    const sn = validateField('name', secondName);
    const e = validateField('email', email);
    const t = validateField('telephone', telephone);
    const c = validateField('city', city);
    const a = validateField('address', address);
    const d = validateField('date', selectedDate);

    dispatch({
      type: 'valid_fields',
      'firstNameIsValid': fn,
      'secondNameIsValid': sn,
      'emailIsValid': e,
      'telephoneIsValid': t,
      'cityIsValid': c,
      'addressIsValid': a,
      'selectedDateIsValid': d,
    });

    return fn && sn && e && t && c && a && d && agreeCheckbox;
  }



  return (<>
    <h2 className='mb-5'>Лична информация</h2>
    <div className='row'>
      <form onSubmit={onSubmit} className='popup-form'>
        <div className="form-row">
          <div className="form-group col-md-6">
            <label htmlFor="firstName">Име</label>
            <input
              type="text"
              className="form-control"
              id="firstName"
              placeholder="e.g. Иван"
              value={firstName}
              onFocus={(e) => e.target.placeholder = ""}
              onBlur={(e) => e.target.placeholder = "e.g. Иван"}
              onChange={(v) => dispatch({
                type: 'form_field',
                field: 'firstName',
                fieldValid: 'firstNameIsValid',
                value: v.currentTarget.value,
              })} />
            {!firstNameIsValid && <small className='text-danger'>Минимум 3 символа</small>}
          </div>

          <div className="form-group col-md-6">
            <label htmlFor="secondName">Фамилия</label>
            <input
              type="text"
              className="form-control"
              id="secondName"
              placeholder="e.g. Петров"
              value={secondName}
              onFocus={(e) => e.target.placeholder = ""}
              onBlur={(e) => e.target.placeholder = "e.g. Петров"}
              onChange={(v) => dispatch({
                type: 'form_field',
                field: 'secondName',
                fieldValid: 'secondNameIsValid',
                value: v.currentTarget.value,
              })} />
            {!secondNameIsValid && <small className='text-danger'>Минимум 3 символа</small>}
          </div>

          <div className="form-group col-md-6">
            <label htmlFor="telephone">Телефон</label>
            <input
              type="text"
              className="form-control"
              id="telephone"
              placeholder="Вашият телефон"
              value={telephone}
              onFocus={(e) => e.target.placeholder = ""}
              onBlur={(e) => e.target.placeholder = "Вашият телефон"}
              onChange={(v) => dispatch({
                type: 'form_field',
                field: 'telephone',
                fieldValid: 'telephoneIsValid',
                value: v.currentTarget.value,
              })} />
            {!telephoneIsValid && <small className='text-danger'>Само цифри</small>}
          </div>

          <div className="form-group col-md-6">
            <label htmlFor="email">Имейл</label>
            <input
              type="text"
              className="form-control"
              id="email"
              placeholder="Вашият имейл"
              value={email}
              onFocus={(e) => e.target.placeholder = ""}
              onBlur={(e) => e.target.placeholder = "Вашият имейл"}
              onChange={(v) => dispatch({
                type: 'form_field',
                field: 'email',
                fieldValid: 'emailIsValid',
                value: v.currentTarget.value,
              })} />
            {!emailIsValid && <small className='text-danger'>Невалиден имейл</small>}
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="city">Град</label>
            <input
              type="text"
              className="form-control"
              id="city"
              placeholder="Град"
              value={city}
              onFocus={(e) => e.target.placeholder = ""}
              onBlur={(e) => e.target.placeholder = "Град"}
              onChange={(v) => dispatch({
                type: 'form_field',
                field: 'city',
                fieldValid: 'cityIsValid',
                value: v.currentTarget.value,
              })} />
            {!cityIsValid && <small className='text-danger'>Минимум 3 символа</small>}
          </div>

          <div className="form-group col-md-8">
            <label htmlFor="address">Адрес на услугата</label>
            <input
              type="text"
              className="form-control"
              id="address"
              placeholder="квартал, район, улица, блок, вход, етаж, апартамент"
              value={address}
              onFocus={(e) => e.target.placeholder = ""}
              onBlur={(e) => e.target.placeholder = "квартал, район, улица, блок, вход, етаж, апартамент"}
              onChange={(v) => dispatch({
                type: 'form_field',
                field: 'address',
                fieldValid: 'addressIsValid',
                value: v.currentTarget.value,
              })} />
            {!addressIsValid && <small className='text-danger'>Минимум 3 символа</small>}
          </div>

          <div className="form-group col-md-6">
            <label htmlFor="text">Предпочитана дата за включване</label>
            <DatePicker
              className={'form-group'}
              minDate={new Date()}
              value={selectedDate}
              onChange={(v) => dispatch({
                type: 'form_field',
                field: 'selectedDate',
                value: v,
              })}
              clearIcon={null}
            />
            {!selectedDateIsValid && <small className='text-danger'>Изберете дата</small>}
          </div>
        </div>

        <button type="submit" className='btn btn-primary green mt-5' disabled={!agreeCheckbox}>Заяви</button>
        <div className="form-check">
          <input type="checkbox" className="form-check-input" id="agreeCheckbox"
            value={agreeCheckbox}
            onChange={(v) => {
              dispatch({
                type: 'form_field',
                field: 'agreeCheckbox',
                value: !agreeCheckbox,
              })
            }}
          />
          <label className="form-check-label" htmlFor="agreeCheckbox">Съгласен съм да съберете личните ми данни по <a href="https://netsurf.bg/wp-content/uploads/2019/12/GDPR_02_12_2019.pdf" target="_blank" rel="noopener noreferrer">GDPR</a>.</label>
        </div>
        {failure && <p className='text-danger'>Грешка при изпращането! Опитай пак.</p>}
      </form>
    </div>


  </>);
};

function formatDate(date) {
  var monthNames = [
    "January", "February", "March",
    "April", "May", "June", "July",
    "August", "September", "October",
    "November", "December"
  ];

  var day = date.getDate();
  var monthIndex = date.getMonth();
  var year = date.getFullYear();

  return day + ' ' + monthNames[monthIndex] + ' ' + year;
}
